// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  height: 100%;
  width: 100%;
  color: black;
}

.jumbotron p {
  font-weight: normal;
}

.navbar {
  margin: 0;
}

#maincontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}
.navbar #maincontent {
  height: calc(100% - 60px);
}
#tutorial, #workframe {
  width: 50%;
  height: 100%;
  display: inline-block;
  border: none;
  float: left;
}
#tutorial {
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1em;
  padding-right: 0.5em;
  background: #f9f9f9;
  resize: horizontal;
  min-width: 10em;
}
#workframe {
  overflow: hidden;
  flex-grow: 100;
}
.codeblock .codeblock_entry {
  width: calc(100% - 6em);
  font-family: monospace;
  margin-bottom: 1em;
  opacity: 0.5;
  font-size: 0.9em;
  line-height: 1.3em;
  background: inherit;
  display: inline-block;
}
.codeblock.active .codeblock_entry {
  opacity: 1;
  background: white;
  resize: vertical;
}
.codeblock .codeblock_entry textarea {
  width: 100%;
}
.codeblock .CodeMirror {
  height: inherit;
  border: 1px solid rgba(0, 0, 0, 0.5);
}
.codeblock_controls {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  width: 5em;
}
.codeblock_controls>button{
  display: block;
  margin: 0.125em auto;
}
.codeblock_controls>button.codeblock_reset {
  font-size: 0.67em;
}
.codeblock .codeblock_active {
  display: none;
}
.codeblock.active .codeblock_active {
  display: inherit;
}
.codeblock.active .codeblock_inactive {
  display: none;
}
.codeblock_test {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./tutorials/common/tutorials.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf","sourcesContent":["html, body {\n  height: 100%;\n  width: 100%;\n  color: black;\n}\n\n.jumbotron p {\n  font-weight: normal;\n}\n\n.navbar {\n  margin: 0;\n}\n\n#maincontent {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n}\n.navbar #maincontent {\n  height: calc(100% - 60px);\n}\n#tutorial, #workframe {\n  width: 50%;\n  height: 100%;\n  display: inline-block;\n  border: none;\n  float: left;\n}\n#tutorial {\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 1em;\n  padding-right: 0.5em;\n  background: #f9f9f9;\n  resize: horizontal;\n  min-width: 10em;\n}\n#workframe {\n  overflow: hidden;\n  flex-grow: 100;\n}\n.codeblock .codeblock_entry {\n  width: calc(100% - 6em);\n  font-family: monospace;\n  margin-bottom: 1em;\n  opacity: 0.5;\n  font-size: 0.9em;\n  line-height: 1.3em;\n  background: inherit;\n  display: inline-block;\n}\n.codeblock.active .codeblock_entry {\n  opacity: 1;\n  background: white;\n  resize: vertical;\n}\n.codeblock .codeblock_entry textarea {\n  width: 100%;\n}\n.codeblock .CodeMirror {\n  height: inherit;\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n.codeblock_controls {\n  display: inline-block;\n  vertical-align: top;\n  text-align: center;\n  width: 5em;\n}\n.codeblock_controls>button{\n  display: block;\n  margin: 0.125em auto;\n}\n.codeblock_controls>button.codeblock_reset {\n  font-size: 0.67em;\n}\n.codeblock .codeblock_active {\n  display: none;\n}\n.codeblock.active .codeblock_active {\n  display: inherit;\n}\n.codeblock.active .codeblock_inactive {\n  display: none;\n}\n.codeblock_test {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
